import React from 'react';
import { getActivityTypeIcon } from '../utils/iconUtils';

interface ActivityTypeSelectorProps {
  onSelectActivityType: (type: string) => void;
  onCancel: () => void;
}

const ActivityTypeSelector: React.FC<ActivityTypeSelectorProps> = ({ 
  onSelectActivityType, 
  onCancel 
}) => {
  const activityTypes = [
    { value: 'lesson', label: 'Bài học' },
    { value: 'quiz', label: 'Kiểm tra' },
    { value: 'exercise', label: 'Bài tập' },
    { value: 'session', label: 'Buổi học' },
    { value: 'assignment', label: 'Bài tập lớn' }
  ];

  const handleTypeSelect = (e: React.MouseEvent, type: string) => {
    e.stopPropagation();
    onSelectActivityType(type);
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.stopPropagation();
    onCancel();
  };

  return (
    <div 
      className="mt-2 bg-white border border-blue-200 rounded-md p-2 shadow-sm"
      onClick={(e) => e.stopPropagation()}
    >
      <p className="text-xs text-gray-600 mb-2">Chọn loại hoạt động:</p>
      <div className="space-y-1">
        {activityTypes.map((type) => (
          <button
            key={type.value}
            onClick={(e) => handleTypeSelect(e, type.value)}
            className="w-full flex items-center p-2 text-sm text-left hover:bg-gray-50 rounded"
          >
            <span className="mr-2">{getActivityTypeIcon(type.value)}</span>
            <span>{type.label}</span>
          </button>
        ))}
      </div>
      <div className="mt-2 flex justify-end">
        <button
          onClick={handleCancel}
          className="text-xs py-1 px-2 text-gray-600 hover:text-gray-800"
        >
          Hủy
        </button>
      </div>
    </div>
  );
};

export default ActivityTypeSelector; 